import { render, staticRenderFns } from "./filterLabelComponent.vue?vue&type=template&id=ca27f758&"
import script from "./filterLabelComponent.vue?vue&type=script&lang=js&"
export * from "./filterLabelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports